"use client";

import { logCrave } from "@/app/actions/crave";
import { useRouter } from "next/navigation";

export function EmergencyButton() {
    const router = useRouter();

    const handleClick = async () => {
        // 1. Log the crave event
        await logCrave();
        // 2. Navigate to the dedicated page
        router.push("/emergency");
    };

    return (
        <button
            onClick={handleClick}
            className="fixed bottom-6 right-6 w-14 h-14 bg-[#dc2626] rounded-full shadow-lg flex items-center justify-center text-white font-bold hover:bg-[#ef4444] hover:scale-105 transition active:scale-95 z-50"
            title="โหมดฉุกเฉิน"
        >
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
        </button>
    );
}
